import React from 'react';

export function ClosedEye () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <g stroke="#717171" clipPath="url(#clip0_18893_221)">
        <path d="M16.929 12.417h0C14.993 14.063 12.542 15.5 10 15.5c-2.542 0-4.993-1.438-6.929-3.083h0a21.891 21.891 0 01-2.244-2.215h0a.306.306 0 010-.404h0a21.9 21.9 0 012.244-2.215l-.323-.381.323.38C5.007 5.938 7.458 4.5 10 4.5c2.542 0 4.993 1.437 6.929 3.083a21.907 21.907 0 012.244 2.215.306.306 0 010 .404l-2.244 2.215zm0 0a21.913 21.913 0 002.244-2.215l-2.244 2.215z" />
        <path strokeLinecap="round" d="M19.5 19.5L.5.5" />
        <circle cx="10" cy="10" r="3" transform="rotate(-180 10 10)" />
      </g>
      <defs>
        <clipPath id="clip0_18893_221">
          <path
            fill="#fff"
            d="M0 0H20V20H0z"
            transform="matrix(-1 0 0 1 20 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
